export default __webpack_public_path__ + "static/media/first.037e66b6.png";